import axios from '@axios';

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchContacts(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/contacts', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        fetchContact(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/contact/${id}/edit`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        deleteContact(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/contact/${id}/delete`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        }
    }
}